import React, {Component} from 'react';
import Nprogress from 'nprogress';
import ReactPlaceholder from 'react-placeholder';
import 'nprogress/nprogress.css';
import 'react-placeholder/lib/reactPlaceholder.css';
import CircularProgress from "../components/CircularProgress/index";
//import Spinner from '../app/routes/Spinner'

async function checkVersion(refresh = 0) {
  try {
    const response = await fetch('/public/version.json');
    if (!response.ok) {
      return;
    }
		console.log('Checking version')
    const data = await response.json();
    const currentVersion = localStorage.getItem('appVersion');
    if (currentVersion && currentVersion !== data.version) {
      console.log("Version mismatch detected. Current:", currentVersion, "New:", data.version);

      if (refresh === 1) {
        console.log("Refreshing page due to version change...");
        localStorage.setItem('appVersion', data.version);
        //window.location.reload(true);
      }
    } 
  } catch (error) {
    console.error("Error checking version:", error);
  }
}

export default function  asyncComponent(importComponent) {
  class AsyncFunc extends Component {
    constructor(props) {
      super(props);
      this.state = {
        component: null
      };
    }

    async componentWillMount() {
     // Nprogress.start();
			try{
      	await checkVersion(1);
			}
			catch (err){}
    }

    componentWillUnmount() {
      this.mounted = false;
    }

    async componentDidMount() {
      this.mounted = true;
      try{
      // await checkVersion(1);
      await importComponent()
      .then(async ({default: Component}) => {
        //Nprogress.done();
        console.log(this.mounted)
        if (this.mounted) {
            this.setState({
              component: <Component {...this.props} />
            });
        }
        else{
         //window.location.reload(true); 
        }
      })
      .catch(err=>{
          console.log(err,"ERRRRRRRR")          
         window.location.reload(true);
      })
      }
    catch(error){
      console.log(error)
    }
    }

    render() {
      const Component = this.state.component ||
        <div className="loader-view"
             style={{height: 'calc(100vh - 170px)'}}>
          <CircularProgress/>
        </div>;
      return (
        <ReactPlaceholder type="text" rows={7} ready={Component !== null}>
          {Component}
        </ReactPlaceholder>
      );
    }
  }

  return AsyncFunc;
}
